var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNetwork2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Statusbar / BTN_Status_Icon_Pos1 / 00_statusbar_network_2_48px_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "B_Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-488.000000, -1420.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Statusbar-/-BTN_Status_Icon_Pos1-/-00_statusbar_network_2_48px_white",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "network_2",
    transform: "translate(2.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "network_x5F_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    opacity: 0.25,
    points: "40 32 44 32 44 0 40 2.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    opacity: 0.25,
    points: "30 8.6 30 32 34 32 34 6.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    opacity: 0.25,
    points: "24 12.3 20 14.7 20 32 24 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,32 L10,32 L10,20.9 L14,18.4 L14,32 Z M4,24.5 L0,27 L0,32 L4,32 L4,24.5 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNetwork2);
export default __webpack_public_path__ + "static/media/icon-network_2.010cefefbb5d36942d0eadff978a4549.svg";
export { ForwardRef as ReactComponent };